import { render } from "./WhereAndWhat.vue?vue&type=template&id=b5fb0308"
import script from "./WhereAndWhat.vue?vue&type=script&lang=js"
export * from "./WhereAndWhat.vue?vue&type=script&lang=js"

import "./WhereAndWhat.vue?vue&type=style&index=0&id=b5fb0308&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__